import angular from 'angular'
import './style.scss'

document.write(require('./view.html').default);

angular.module("core.application.main").directive("core.application.main.directive.pagination", [
    "$location", "$route",
    function($location, $route) {
        // pages are zero based
        // so currentPage of 0 is actually the first page
        var expose = {};
        expose.restrict = "A";
        expose.templateUrl = "pagination.html";
        expose.scope = {
            pagination: "=",
        };

        expose.link = function($scope) {
            $scope.maximumPages = 9;
            $scope.totalPages = 0;
            $scope.pages = [];

            // We alter $route.search to ensure the page number query
            // parameter is kept up to date so that if the user refreshes
            // the page or presses the back button they will still be on the
            // same page as before.
            // When $route.search is changed, Angular will automatically reload
            // all of the controllers for the page which will reset our object
            // state.  We don't want this to happen because it will trigger
            // multiple 'page change' events which means that the calling code
            // could end up asking the backend for data twice instead of just once.
            // So we disable that feature to ensure we reuse the same instance
            // of the controller for the current route
            $route.current.$$route.reloadOnSearch = false;

            var calculatePages = function(totalItems, itemsPerPage) {
                var pageIndex;
                $scope.pages = [];
                if (totalItems && itemsPerPage) {
                    $scope.totalPages = Math.ceil(totalItems / itemsPerPage);
                    for (pageIndex = 0; pageIndex < $scope.totalPages; pageIndex++) {
                        $scope.pages.push(pageIndex);
                    }
                    $scope.truncatePages();
                    $scope.pagination.isLastPage = ($scope.pagination.currentPage === $scope.lastPage());
                }
            };

            $scope.paginationVisible = function() {
                return $scope.pages.length > 1;
            };

            $scope.changePage = function(pageNumber) {
                pageNumber = parseInt(pageNumber, 0);
                if (! pageNumber || pageNumber < 0) {
                    pageNumber = 0;
                }
                $scope.pagination.currentPage = pageNumber;
                $scope.pagination.itemOffset = $scope.pagination.currentPage * $scope.pagination.itemsPerPage;
            };

            $scope.goToPreviousPage = function() {
                if ($scope.hasPreviousPages()) {
                    $scope.changePage(--$scope.pagination.currentPage);
                }
            };

            $scope.goToNextPage = function() {
                if ($scope.hasNextPages()) {
                    $scope.changePage(++$scope.pagination.currentPage);
                }
            };

            $scope.goToFirstPage = function() {
                if ($scope.hasPreviousPages()) {
                    $scope.changePage(0);
                }
            };

            $scope.goToLastPage = function() {
                if ($scope.hasNextPages()) {
                    $scope.changePage($scope.lastPage());
                }
            };

            $scope.lastPage = function() {
                return $scope.totalPages - 1;
            };

            $scope.hasPreviousPages = function() {
                return $scope.pagination.currentPage > 0;
            };

            $scope.hasNextPages = function() {
                return $scope.pagination.currentPage < $scope.lastPage();
            };

            $scope.truncatePages = function() {
                // if the total pages is beyond the maximum then we need to
                // truncate them. Also if we've gone beyond the end of the pages or
                // before the beginning of the pages then we need to rotate
                // the truncation appropriately
                var forwardTruncate;
                var backwardTruncate;
                var currentPage = $scope.pagination.currentPage;
                var pageTruncateOffset = Math.ceil($scope.maximumPages / 2);
                if ($scope.totalPages > $scope.maximumPages) {
                    forwardTruncate = currentPage + pageTruncateOffset;
                    backwardTruncate = currentPage - pageTruncateOffset + 1;

                    if (forwardTruncate > $scope.pages.length) {
                        backwardTruncate += $scope.pages.length - forwardTruncate;
                        forwardTruncate = $scope.pages.length;
                    } else if (backwardTruncate < 0) {
                        forwardTruncate -= backwardTruncate;
                        backwardTruncate = 0;
                    }

                    $scope.pages.splice(forwardTruncate);
                    $scope.pages = $scope.pages.splice(backwardTruncate);
                }
            };

            if ($location.search().page !== undefined) {
                // if the page number query parameter is already set then change
                // to that page. This happens when the user refreshes the page
                $scope.changePage($location.search().page - 1);
            } else {
                // otherwise just fallback to the first page as a default
                $scope.changePage(0);
            }

            $scope.$watch("pagination", function() {
                var displayedPageNumber = $scope.pagination.currentPage + 1;
                if ($location.search().page !== displayedPageNumber) {
                    // keep the page number query parameter up to date
                    // based on page data in case the page is refreshed
                    // or the back button pressed
                    if ($location.search().page === undefined) {
                        // if the pagination query parameters have never been set
                        // then just replace the current url so we don't add
                        // to the navigation history so when pressing the
                        // back button we go straight back
                        // /orders?page=1 --> /
                        // instead of
                        // /orders?page=1 --> /orders --> /
                        $location.search("page", displayedPageNumber).replace();
                    } else {
                        $location.search("page", displayedPageNumber);
                    }
                }
                calculatePages(
                    $scope.pagination.totalItems,
                    $scope.pagination.itemsPerPage
                );
            }, true);

            $scope.$on("$routeUpdate", function() {
                // when the back button is pressed we need to make sure the
                // right page number from the query parameter is used
                $scope.changePage($location.search().page - 1);
            });
        };

        return expose;
    }
]);
